import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Divider from '@material-ui/core/Divider';

const RequestAppliedOffersSkeleton = () => {

    return (
        <>
            <Skeleton height={100} />
            <Skeleton height={100} />
            <Skeleton height={100} />
        </>
    );
}

export default RequestAppliedOffersSkeleton;